import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sentinel"]

  #observer

  initialize() {
    this.#observer = new IntersectionObserver(([entry]) => this.#load(entry), { rootMargin: "200px" })
  }

  disconnect() {
    this.#observer.disconnect()
  }

  sentinelTargetConnected(el) {
    this.#observer.observe(el)
  }

  sentinelTargetDisconnected(el) {
    this.#observer.unobserve(el)
  }

  async #load(entry) {
    if (!entry.isIntersecting) return
    const sentinel = entry.target
    this.#observer.unobserve(sentinel)
    const url = sentinel.dataset.url
    sentinel.remove()
    try {
      const response = await fetch(url, { headers: { "X-Infinite-Scroll": "1", Accept: "text/html" } })
      if (!response.ok) return
      this.element.insertAdjacentHTML("beforeend", await response.text())
    } catch {
      // network error — sentinel already removed, scroll will not retry
    }
  }
}
